<div class="flex--row flex--align-center table-toolbar-button-group">
  <mat-form-field class="date-picker-input" [ngModel]="">
    <mat-date-range-input class="date-picker-input" [rangePicker]="picker" [min]="minimalDate()" [max]="maximalDate()">
      <input
        hidden
        matStartDate
        class="date-picker-input"
        [ngModel]="dateStore.startDatePicker()"
        (dateChange)="onStartPickerChange($event)"
      />
      <input
        hidden
        matEndDate
        class="date-picker-input"
        [ngModel]="dateStore.endDatePicker()"
        (dateChange)="onEndPickerChange($event)"
      />
    </mat-date-range-input>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  <button class="table-toolbar-icon-button" (click)="picker.open()">
    <mat-icon>today</mat-icon>
  </button>
  <button class="table-toolbar-icon-button" [disabled]="previousButtonDisabled()" (click)="onPreviousDay()">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <button class="table-toolbar-icon-button" [disabled]="nextButtonDisabled()" (click)="onNextDay()">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
